import _debounce from 'lodash/debounce';
import React, { Component, PropsWithChildren } from 'react';
import { AutoSizer, Size } from 'react-virtualized/dist/es/AutoSizer';
import { IAutoScaleProps } from './types';

export interface IAutoScaleState {
  width: number;
  height: number;
}

export class AutoScale extends Component<PropsWithChildren<IAutoScaleProps>, IAutoScaleState> {
  public wrapper: HTMLDivElement | null;
  public state = {
    height: 0,
    width: 0,
  };

  public handleResize = _debounce((size: Size) => {
    if (!this.wrapper) {
      return;
    }

    const width = this.props.width || size.width;
    const height = this.props.height || size.height;

    if (this.props.debounce) {
      if (this.timerRef) {
        clearTimeout(this.timerRef);
      }

      this.timerRef = setTimeout(() => {
        this.timerRef = null;
        this.setState((prevState) => ({ width, height }));
      }, this.props.debounce);
    } else {
      this.setState({ width, height });
    }
  }, 100);

  private timerRef: any;

  public componentWillUnmount() {
    if (this.timerRef) {
      clearTimeout(this.timerRef);
    }
  }

  public render() {
    const { width, height } = { ...this.state, ...this.props };

    const style = { height, width };

    if (this.props.debounce) {
      Object.assign(style, { overflow: 'hidden' });
    }

    return (
      <AutoSizer onResize={this.handleResize}>
        {() => (
          <div className="chart-wrapper" style={style} ref={(node) => (this.wrapper = node)}>
            {width > 0 && height > 0 && this.props.render({ height, width })}
          </div>
        )}
      </AutoSizer>
    );
  }
}

export default AutoScale;
